import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    backgroundColor: '#FFFFFF',
    color: '#000000',
  },
  header: {
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '1px solid #E5E7EB',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  subtitle: {
    fontSize: 14,
    color: '#6B7280',
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#111827',
    borderBottom: '1px solid #E5E7EB',
    paddingBottom: 5,
  },
  checklist: {
    marginLeft: 10,
  },
  checklistItem: {
    marginBottom: 5,
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 10,
    color: '#9CA3AF',
    borderTop: '1px solid #E5E7EB',
    paddingTop: 10,
  },
});

const docTypes = {
  homeLoan: [
    "Photo ID & Social Security card",
    "Income verification: last 30 days' pay stubs",
    "W-2s, tax returns (2 years)",
    "Profit/loss statements for self-employed",
    "Employment history and VOE (last 2 years)",
    "Bank and asset statements (2-3 months)",
    "Credit report and credit history overview",
    "Debt documentation: credit cards, car loans, student loans",
    "Purchase contract and earnest money deposit proof",
    "Insurance documents: homeowner's, flood (if required)",
    "Special documents: divorce decree, child support documents"
  ],
  businessLoan: [
    "Business and personal tax returns (2+ years)",
    "Business profit & loss statements, balance sheet",
    "Bank statements for business accounts (2-3 months)",
    "Business license and registration",
    "Commercial lease agreements (if applicable)",
    "Business plan and financial projections"
  ],
  mortgageLoan: [
    "Photo ID & Social Security card",
    "Income verification: last 30 days' pay stubs, W-2s (2 years)",
    "Tax returns (2 years) with all schedules",
    "Business tax returns (if self-employed)",
    "Bank statements (2-3 months for all accounts)",
    "Investment and retirement account statements",
    "Existing mortgage statements (if applicable)",
    "Proof of rental income (if applicable)",
    "Gift letter (if using gift funds)",
    "Bankruptcy/foreclosure documents (if applicable)",
    "VA/Government loan documents (if applicable)",
    "Homeowners insurance information",
    "Property tax information",
    "HOA documents (if applicable)",
    "Purchase agreement (for new purchases)",
    "Proof of down payment and closing costs"
  ],
  projectLoan: [
    "Detailed project report with cost estimates",
    "Land/property documents and title deeds",
    "Approved building plans and NOCs",
    "Construction schedule and contractor details",
    "Projected cash flows and financials",
    "Personal and business financial statements",
    "Tax returns (3 years)",
    "Bank statements (6 months)",
    "Collateral documents"
  ],
  personalLoan: [
    "Valid government-issued photo ID (e.g., passport, driver's license)",
    "Social Security/Tax ID",
    "Proof of income: recent pay stubs (1-2 months)",
    "W-2s or tax returns (1-2 years)",
    "1099s (for freelancers)",
    "Bank account statements (last 2-3 months)",
    "Proof of residence (utility bill, lease)",
    "Recent credit report pulled by lender",
    "Additional documentation: asset proof, letters for alimony/child support, employer verification"
  ],
  educationLoan: [
    "Admission letter from the educational institution",
    "Fee structure from the institution",
    "Academic records and mark sheets",
    "Co-applicant's income proof",
    "Identity and address proof",
    "Collateral documents (if applicable)",
    "Scholarship/grant award letters (if any)"
  ],
  newCarLoan: [
    "Driver's license",
    "Salary slips (last 3 months)",
    "Bank statements (6 months)",
    "Income Tax Returns (2 years)",
    "Address proof",
    "Car quotation from dealer",
    "Down payment proof"
  ],
  usedCarLoan: [
    "Driver's license",
    "Salary slips (last 3 months)",
    "Bank statements (6 months)",
    "Income Tax Returns (2 years)",
    "Address proof",
    "RC book of the car",
    "Car insurance papers",
    "Form 32/35 (for hypothecation removal)",
    "PUC certificate",
    "Car valuation report"
  ],
  goldLoan: [
    "Identity proof (Aadhaar, Voter ID, etc.)",
    "Address proof",
    "Passport size photos",
    "Gold ornaments (as collateral)",
    "Purity certificate (if available)"
  ],
  creditCard: [
    "Identity proof (PAN Card mandatory)",
    "Address proof",
    "Latest 3 months' salary slips",
    "Bank statements (3-6 months)",
    "Passport size photographs",
    "ITR with computation of income (if self-employed)",
    "Employment proof (if salaried)",
    "Business proof (if self-employed)",
    "Existing credit card statements (if any)",
    "Income tax returns (if self-employed)"
  ]
};

const DocumentationChecklist = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={styles.title}>Loan Documentation Checklist</Text>
        <Text style={styles.subtitle}>Complete List of Required Documents</Text>
      </View>

      {Object.entries(docTypes).map(([type, docs]) => (
        <View key={type} style={styles.section}>
          <Text style={styles.sectionTitle}>
            {type === 'personalLoan' ? 'Personal Loan' : 
           type === 'homeLoan' ? 'Home Loan' : 
           type === 'mortgage' ? 'Mortgage Loan' : 
           type === 'businessLoan' ? 'Business Loan' : 
           type === 'carLoan' ? 'Car Loan' : 
           type === 'educationLoan' ? 'Education Loan' : ''} Documents:
          </Text>
          <View style={styles.checklist}>
            {docs.map((doc, i) => (
              <View key={i} style={styles.checklistItem}>
                <Text>• {doc}</Text>
              </View>
            ))}
          </View>
        </View>
      ))}

      <View style={styles.footer}>
        <Text>© {new Date().getFullYear()} White Pearl Finance - Documentation Checklist</Text>
      </View>
    </Page>
  </Document>
);

export default DocumentationChecklist;
